import React, { useEffect, useState } from "react";
import { methods } from "../constants";
import { getNewLine } from "../utilities";
import marshallData from "../data/computeInitialWidgetData";
import createCsv, { downloadAnnotatedCsv } from "../data/csv";
import {
  calculateTheme1ProjectedFundingGapsByGniGroupTableData,
  calculateTheme1ProjectedFundingGapsBySectorTableData,
  calculateTheme1ProjectedFundingGapsWithinPublicSectorTableData,
  calculateTheme2MethodMixWithinSectorChartData,
  calculateTheme2ShareOfUsersChartData,
  calculateTheme2UsersByMethodChartData,
  calculateTheme2UsersBySectorTableData,
  calculateTheme3ShareOfUsersWithinPrivateSectorByMethodChartData,
  calculateTheme3ShareWithinPrivateSectorByGniGroupChartData,
  calculateTheme4ConsumptionCostChartData,
  calculateTheme4MethodMixOfUseVsCostChartData,
  calculateTheme4ShareOfConsumptionCostsVsUsersBySectorChartData,
  calculateTheme4ShareOfUsersVsCostChartData,
  calculateTheme5ChangeByGniGroupChartData,
  calculateTheme5ChangeByGniGroupTableData,
  calculateTheme5ChangeByMethodChartData,
  calculateTheme5ChangeInMethodMixChartData,
  calculateTheme5MethodMixChartData
} from "../data/widgetData";
import {
  calculateCountryExplorerCurrentChartData,
  calculateCountryExplorerProjectionChartData
} from "../data/countryExplorerData";
import calculateAnnexTableData from "../data/annexTableData";
import App from "../components/App";
import { summarize } from "../data/data";

const theme3PrivateSectorPricesByMethodTableData = [
  ["", "Private Subsidized", "", "", "", "Private Non-Subsidized", "", "", ""],
  [
    "",
    "Implant",
    "IUD",
    "Injection",
    "Pill",
    "Implant",
    "IUD",
    "Injection",
    "Pill"
  ],
  ["Asia", "0.87", "0.31", "0.43", "0.07", "44.24", "7.75", "1.40", "3.11"],
  ["Europe", "", "", "", "", "181.72", "5.00", "1.92", "7.06"],
  ["Africa", "4.17", "0.44", "0.70", "0.15", "14.60", "7.57", "1.09", "0.66"],
  ["Americas", "0.62", "", "0.49", "", "29.34", "21.83", "4.37", "5.31"],
  ["Total", "3.68", "0.37", "0.68", "0.13", "31.09", "12.55", "2.22", "3.14"]
];

const theme3SubsidizedPricesAsShareOfNonSubsidizedPriceTable = [
  ["", "Implant", "IUD", "Injection", "Pill"],
  ["Asia", "2", "4", "31", "2"],
  ["Europe", "", "", "", ""],
  ["Africa", "29", "6", "64", "23"],
  ["Americas", "2", "", "11", ""],
  ["Total", "12", "3", "31", "4"]
];

const createChangeByGniGroupTableCsv = (data, settings) =>
  createCsv(
    [
      "",
      "",
      "",
      "",
      "5-yr Change (2020 to 2025)",
      "",
      "5-yr Change (2025 to 2030)",
      ""
    ],
    "area",
    "year",
    ["LIC", "L-MIC", "U-MIC", "Total"],
    ["", "2020", "2025", "2030", "#", "%", "#", "%"],
    [
      "Low-Income (LIC)",
      "Lower-Middle-Income (L-MIC)",
      "Upper-Middle-Income (U-MIC)",
      "Total"
    ],
    [
      "2020",
      "2025",
      "2030",
      "# (2020-2025)",
      "% (2020-2025)",
      "# (2025-2030)",
      "% (2025-2030)"
    ],
    data,
    settings,
    ""
  );

const createChangeByMethodCsv = (data, settings) =>
  createCsv(
    undefined,
    "method",
    "year",
    undefined,
    undefined,
    methods,
    ["2020", "2025", "2030"],
    data,
    settings,
    ""
  );

const createChangeByGniGroupCsv = (data, settings) =>
  createCsv(
    undefined,
    "area",
    "year",
    ["LIC", "L-MIC", "U-MIC"],
    undefined,
    [
      "Low-Income (LIC)",
      "Lower-Middle-Income (L-MIC)",
      "Upper-Middle-Income (U-MIC)"
    ],
    ["2020", "2025", "2030"],
    data,
    settings,
    ""
  );

const createContraceptionCsv = (data, settings, includeTotalRow = true) =>
  createCsv(
    ["", "", "", "", "Within Private", ""],
    "method",
    "sector",
    undefined,
    ["", "Total", "Public", "Private", "Subsidized", "Non-Subsidized"],
    includeTotalRow ? [...methods, "Total"] : methods,
    ["Total", "Public", "Private", "Private Sub", "Private Non-Sub"],
    data,
    settings,
    ""
  );

const createMethodMixAndShareCsv = (
  data,
  settings,
  includeMix = true,
  includeTotalRow = true
) =>
  (includeMix ? ",Method Mix,,,,,Method Share,,,," : ",Method Share,,,,") +
  getNewLine() +
  createCsv(
    [
      "",
      "",
      "",
      "",
      "Within Private",
      "",
      "",
      "",
      "",
      "Within Private",
      ""
    ].slice(includeMix ? 0 : 5),
    "method",
    "sector",
    undefined,
    [
      "",
      "Total",
      "Public",
      "Private",
      "Subsidized",
      "Non-Subsidized",
      "Total",
      "Public",
      "Private",
      "Subsidized",
      "Non-Subsidized"
    ].slice(0, includeMix ? undefined : 6),
    includeTotalRow ? [...methods, "Total"] : methods,
    [
      "Total (Mix)",
      "Public (Mix)",
      "Private (Mix)",
      "Private Sub (Mix)",
      "Private Non-Sub (Mix)",
      "Total (Share)",
      "Public (Share)",
      "Private (Share)",
      "Private Sub (Share)",
      "Private Non-Sub (Share)"
    ].slice(includeMix ? 0 : 5),
    data,
    settings,
    ""
  );

const createChangeCsv = (data, settings, includeTotalRow = true) =>
  createCsv(
    [
      "",
      "",
      "",
      "",
      "5-yr Change (2020 to 2025)",
      "",
      "5-yr Change (2025 to 2030)",
      "",
      "10-yr Change (2020 to 2030)",
      ""
    ],
    "method",
    "year",
    undefined,
    ["", "2020", "2025", "2030", "#", "%", "#", "%", "#", "%"],
    includeTotalRow ? [...methods, "Total"] : methods,
    [
      "2020",
      "2025",
      "2030",
      "# (2020-2025)",
      "% (2020-2025)",
      "# (2025-2030)",
      "% (2025-2030)",
      "# (2020-2030)",
      "% (2020-2030)"
    ],
    data,
    settings,
    ""
  );

const AppContainer = () => {
  const [data, setData] = useState();

  useEffect(() => {
    async function fetchData() {
      const response = await fetch(`${process.env.PUBLIC_URL}/data.json`);
      let data = await response.json();

      if (!data.widgetData) {
        data = marshallData(data);

        console.log("Pre-computed database:");
        console.log(JSON.stringify(data));
      }

      setData(data);
    }

    fetchData().catch(console.error);
  }, []);

  const handleWidgetChange = ({ widget, payload }) => {
    console.log(`Widget ${widget} changed`);
    console.log(payload);

    switch (widget) {
      // Table 1.2
      case "theme1.projectedFundingGapsBySectorTable":
        setData({
          ...data,
          widgetData: {
            ...data.widgetData,
            theme1: {
              ...data.widgetData.theme1,
              projectedFundingGapsBySectorTable: calculateTheme1ProjectedFundingGapsBySectorTableData(
                data.databases,
                payload.areaId
              )
            }
          }
        });

        break;

      // Table 1.3
      case "theme1.projectedFundingGapsWithinPublicSectorTableWidget":
        setData({
          ...data,
          widgetData: {
            ...data.widgetData,
            theme1: {
              ...data.widgetData.theme1,
              projectedFundingGapsWithinPublicSectorTable: calculateTheme1ProjectedFundingGapsWithinPublicSectorTableData(
                data.databases,
                payload.areaId
              )
            }
          }
        });

        break;

      // Table 1.4
      case "theme1.projectedFundingGapsByGniGroupTable":
        setData({
          ...data,
          widgetData: {
            ...data.widgetData,
            theme1: {
              ...data.widgetData.theme1,
              projectedFundingGapsByGniGroupTable: calculateTheme1ProjectedFundingGapsByGniGroupTableData(
                data.databases,
                payload.sectorId
              )
            }
          }
        });

        break;

      // Figure 2.1
      case "theme2.usersByMethodChart":
        setData({
          ...data,
          widgetData: {
            ...data.widgetData,
            theme2: {
              ...data.widgetData.theme2,
              usersByMethodChart: calculateTheme2UsersByMethodChartData(
                data.databases,
                payload.areaId
              )
            }
          }
        });

        break;

      // Table 2.1
      case "theme2.usersBySectorTable":
        setData({
          ...data,
          widgetData: {
            ...data.widgetData,
            theme2: {
              ...data.widgetData.theme2,
              usersBySectorTable: calculateTheme2UsersBySectorTableData(
                data.databases,
                payload.methodId
              )
            }
          }
        });

        break;

      // Figure 2.2
      case "theme2.shareOfUsersChart":
        setData({
          ...data,
          widgetData: {
            ...data.widgetData,
            theme2: {
              ...data.widgetData.theme2,
              shareOfUsersChart: calculateTheme2ShareOfUsersChartData(
                data.databases,
                payload.methodId
              )
            }
          }
        });

        break;

      // Figure 2.3
      case "theme2.methodMixWithinSectorChart":
        setData({
          ...data,
          widgetData: {
            ...data.widgetData,
            theme2: {
              ...data.widgetData.theme2,
              methodMixWithinSectorChart: calculateTheme2MethodMixWithinSectorChartData(
                data.databases,
                payload.sectorId
              )
            }
          }
        });

        break;

      // Figure 3.2
      case "theme3.shareOfUsersWithinPrivateSectorByMethodChart":
        setData({
          ...data,
          widgetData: {
            ...data.widgetData,
            theme3: {
              ...data.widgetData.theme3,
              shareOfUsersWithinPrivateSectorByMethodChart: calculateTheme3ShareOfUsersWithinPrivateSectorByMethodChartData(
                data.databases,
                payload.areaId
              )
            }
          }
        });
        break;

      // Figure 3.3
      case "theme3.shareWithinPrivateSectorByGniGroupUserChart":
        setData({
          ...data,
          widgetData: {
            ...data.widgetData,
            theme3: {
              ...data.widgetData.theme3,
              shareWithinPrivateSectorByGniGroupUserChart: calculateTheme3ShareWithinPrivateSectorByGniGroupChartData(
                data.databases,
                4,
                payload.methodId
              )
            }
          }
        });

        break;

      // Figure 3.4
      case "theme3.shareWithinPrivateSectorByGniGroupCostChart":
        setData({
          ...data,
          widgetData: {
            ...data.widgetData,
            theme3: {
              ...data.widgetData.theme3,
              shareWithinPrivateSectorByGniGroupCostChart: calculateTheme3ShareWithinPrivateSectorByGniGroupChartData(
                data.databases,
                6,
                payload.methodId
              )
            }
          }
        });

        break;

      // Figure 4.1
      case "theme4.methodMixOfUseVsCostChart":
        setData({
          ...data,
          widgetData: {
            ...data.widgetData,
            theme4: {
              ...data.widgetData.theme4,
              methodMixOfUseVsCostChart: calculateTheme4MethodMixOfUseVsCostChartData(
                data.databases,
                payload.areaId
              )
            }
          }
        });

        break;

      // Figure 4.3
      case "theme4.consumptionCostChart":
        setData({
          ...data,
          widgetData: {
            ...data.widgetData,
            theme4: {
              ...data.widgetData.theme4,
              consumptionCostChart: calculateTheme4ConsumptionCostChartData(
                data.databases,
                payload.areaId
              )
            }
          }
        });

        break;

      // Figure 4.4
      case "theme4.methodMixOfUseVsCostBySectorChart":
        setData({
          ...data,
          widgetData: {
            ...data.widgetData,
            theme4: {
              ...data.widgetData.theme4,
              methodMixOfUseVsCostBySectorChart: calculateTheme4MethodMixOfUseVsCostChartData(
                data.databases,
                payload.areaId,
                payload.sectorId
              )
            }
          }
        });

        break;

      // Figure 4.5
      case "theme4.shareOfUsersVsCostChart":
        setData({
          ...data,
          widgetData: {
            ...data.widgetData,
            theme4: {
              ...data.widgetData.theme4,
              shareOfUsersVsCostChart: calculateTheme4ShareOfUsersVsCostChartData(
                data.databases,
                payload.methodId
              )
            }
          }
        });

        break;

      // Figure 4.7
      case "theme4.shareOfConsumptionCostsVsUsersBySectorChart":
        setData({
          ...data,
          widgetData: {
            ...data.widgetData,
            theme4: {
              ...data.widgetData.theme4,
              shareOfConsumptionCostsVsUsersBySectorChart: calculateTheme4ShareOfConsumptionCostsVsUsersBySectorChartData(
                data.databases,
                payload.methodId
              )
            }
          }
        });

        break;

      // Figure 5.1
      case "theme5.changeByMethodUserChart":
        setData({
          ...data,
          widgetData: {
            ...data.widgetData,
            theme5: {
              ...data.widgetData.theme5,
              changeByMethodUserChart: calculateTheme5ChangeByMethodChartData(
                data.databases,
                payload.areaId,
                4
              )
            }
          }
        });

        break;

      // Figure 5.2
      case "theme5.changeInMethodMixChart":
        setData({
          ...data,
          widgetData: {
            ...data.widgetData,
            theme5: {
              ...data.widgetData.theme5,
              changeInMethodMixChart: calculateTheme5ChangeInMethodMixChartData(
                data.databases,
                payload.areaId
              )
            }
          }
        });

        break;

      // Table 5.1
      case "theme5.changeByGniGroupUserTable":
        setData({
          ...data,
          widgetData: {
            ...data.widgetData,
            theme5: {
              ...data.widgetData.theme5,
              changeByGniGroupUserTable: calculateTheme5ChangeByGniGroupTableData(
                data.databases,
                4,
                payload.methodId
              )
            }
          }
        });

        break;

      // Figure 5.3
      case "theme5.changeByGniGroupUserChart":
        setData({
          ...data,
          widgetData: {
            ...data.widgetData,
            theme5: {
              ...data.widgetData.theme5,
              changeByGniGroupUserChart: calculateTheme5ChangeByGniGroupChartData(
                data.databases,
                4,
                payload.methodId
              )
            }
          }
        });

        break;

      // Figure 5.4
      case "theme5.methodMixChart":
        setData({
          ...data,
          widgetData: {
            ...data.widgetData,
            theme5: {
              ...data.widgetData.theme5,
              methodMixChart: calculateTheme5MethodMixChartData(
                data.databases,
                payload.areaId
              )
            }
          }
        });

        break;

      // Figure 5.5
      case "theme5.changeByMethodCostChart":
        setData({
          ...data,
          widgetData: {
            ...data.widgetData,
            theme5: {
              ...data.widgetData.theme5,
              changeByMethodCostChart: calculateTheme5ChangeByMethodChartData(
                data.databases,
                payload.areaId,
                6
              )
            }
          }
        });

        break;

      // Table 5.2
      case "theme5.changeByGniGroupCostTable":
        setData({
          ...data,
          widgetData: {
            ...data.widgetData,
            theme5: {
              ...data.widgetData.theme5,
              changeByGniGroupCostTable: calculateTheme5ChangeByGniGroupTableData(
                data.databases,
                6,
                payload.methodId
              )
            }
          }
        });

        break;

      // Figure 5.6
      case "theme5.changeByGniGroupCostChart":
        setData({
          ...data,
          widgetData: {
            ...data.widgetData,
            theme5: {
              ...data.widgetData.theme5,
              changeByGniGroupCostChart: calculateTheme5ChangeByGniGroupChartData(
                data.databases,
                6,
                payload.methodId
              )
            }
          }
        });

        break;

      default:
        break;
    }
  };

  const handleDownloadCsv = (id, settings) => {
    console.log(`Download CSV for ${id}`);

    const [theme, widget] = id.split(".");

    console.log(data.widgetData[theme] && data.widgetData[theme][widget]);

    if (settings) {
      console.log(settings);
    }

    const newLine = getNewLine();

    let csv;

    switch (id) {
      case "theme1.currentSpendingBySectorTable":
        csv = createCsv(
          ["", "", "", "Within Public", "", "", "Within Private", ""],
          "area",
          "sector",
          ["LIC", "L-MIC", "U-MIC", "Total"],
          [
            "",
            "Total",
            "Public",
            "Donor",
            "Government",
            "Private",
            "Subsidized",
            "Non-Subsidized"
          ],
          [
            "Low-Income (LIC)",
            "Lower-Middle-Income (L-MIC)",
            "Upper-Middle-Income (U-MIC)",
            "Total"
          ],
          [
            "Total",
            "Public",
            "Donor",
            "Government",
            "Private",
            "Private Sub",
            "Private Non-Sub"
          ],
          data.widgetData.theme1.currentSpendingBySectorTable,
          settings
        );

        downloadAnnotatedCsv(csv, "current_spending_by_sector_table.csv");

        break;

      case "theme1.projectedFundingGapsBySectorTable":
        csv = createCsv(
          ["", "Total", "", "", "Public", "", "", "Private", "", ""],
          "year",
          "indicator",
          undefined,
          [
            "",
            "Spending",
            "Cost Share",
            "Gap",
            "Spending",
            "Cost Share",
            "Gap",
            "Spending",
            "Cost Share",
            "Gap"
          ],
          [
            "Current",
            "2020",
            "2025",
            "Change (#)",
            "Change (%)",
            "Cumulative (5 yr)"
          ],
          [
            "Spend (Total)",
            "Cost Share (Total)",
            "Gap (Total)",
            "Spend (Public)",
            "Cost Share (Public)",
            "Gap (Public)",
            "Spend (Private)",
            "Cost Share (Private)",
            "Gap (Private)"
          ],
          summarize(data.widgetData.theme1.projectedFundingGapsBySectorTable, [
            "indicator",
            "sector",
            "year"
          ]),
          settings,
          ""
        );

        downloadAnnotatedCsv(csv, "projected_funding_gaps_by_sector_table.csv");

        break;

      case "theme1.projectedFundingGapsWithinPublicSectorTable":
        csv = createCsv(
          ["", "Donors", "", "", "Government", "", ""],
          "year",
          "indicator",
          undefined,
          [
            "",
            "Spending",
            "Cost Share",
            "Gap",
            "Spending",
            "Cost Share",
            "Gap"
          ],
          [
            "Current",
            "2020",
            "2025",
            "Change (#)",
            "Change (%)",
            "Cumulative (5 yr)"
          ],
          [
            "Spend (Donor)",
            "Cost Share (Donor)",
            "Gap (Donor)",
            "Spend (Government)",
            "Cost Share (Government)",
            "Gap (Government)"
          ],
          data.widgetData.theme1.projectedFundingGapsWithinPublicSectorTable,
          settings,
          ""
        );

        downloadAnnotatedCsv(
          csv,
          "projected_funding_gaps_within_public_sector_table.csv"
        );

        break;

      case "theme1.projectedFundingGapsByGniGroupTable":
        csv = createCsv(
          ["", "2020", "", "", "2025", "", ""],
          "area",
          "indicator",
          ["LIC", "L-MIC", "U-MIC", "Total"],
          [
            "",
            "Cost Share",
            "Gap",
            "Gap as % of Cost Share",
            "Cost Share",
            "Gap",
            "Gap as % of Cost Share"
          ],
          [
            "Low-Income (LIC)",
            "Lower-Middle-Income (L-MIC)",
            "Upper-Middle-Income (U-MIC)",
            "Total"
          ],
          [
            "Cost Share (2020)",
            "Gap (2020)",
            "Gap as % of Cost Share (2020)",
            "Cost Share (2025)",
            "Gap (2025)",
            "Gap as % of Cost Share (2025)"
          ],
          data.widgetData.theme1.projectedFundingGapsByGniGroupTable,
          settings,
          ""
        );

        downloadAnnotatedCsv(
          csv,
          "projected_funding_gaps_by_gni_group_table.csv"
        );

        break;

      case "theme2.usersBySectorTable":
        csv = createCsv(
          ["", "", "", "", "Within Private", ""],
          "area",
          "sector",
          ["LIC", "L-MIC", "U-MIC", "Total"],
          ["", "Total", "Public", "Private", "Subsidized", "Non-Subsidized"],
          [
            "Low-Income (LIC)",
            "Lower-Middle-Income (L-MIC)",
            "Upper-Middle-Income (U-MIC)",
            "Total"
          ],
          ["Total", "Public", "Private", "Private Sub", "Private Non-Sub"],
          data.widgetData.theme2.usersBySectorTable,
          settings,
          ""
        );

        downloadAnnotatedCsv(csv, "users_by_sector_table.csv");

        break;

      case "theme3.privateSectorPricesByMethodTable":
        csv = theme3PrivateSectorPricesByMethodTableData
          .map(row => row.join(","))
          .join(newLine);

        downloadAnnotatedCsv(csv, "private_sector_prices_by_method_table.csv");

        break;

      case "theme3.subsidizedPricesAsShareOfNonSubsidizedPriceTable":
        csv = theme3SubsidizedPricesAsShareOfNonSubsidizedPriceTable
          .map(row => row.join(","))
          .join(newLine);

        downloadAnnotatedCsv(
          csv,
          "subsidized_prices_as_share_of_non_subsidized_price_table.csv"
        );

        break;

      case "theme5.changeByMethodUserChart":
        csv = createChangeByMethodCsv(
          data.widgetData.theme5.changeByMethodUserChart,
          settings
        );

        downloadAnnotatedCsv(csv, "change_by_method_user_chart.csv");

        break;

      case "theme5.changeInMethodMixChart":
        csv = createChangeByMethodCsv(
          data.widgetData.theme5.changeInMethodMixChart,
          settings
        );

        downloadAnnotatedCsv(csv, "change_in_method_mix_chart.csv");

        break;

      case "theme5.changeByGniGroupUserTable":
        csv = createChangeByGniGroupTableCsv(
          data.widgetData.theme5.changeByGniGroupUserTable,
          settings
        );

        downloadAnnotatedCsv(csv, "change_by_gni_group_user_table.csv");

        break;

      case "theme5.changeByGniGroupUserChart":
        csv = createChangeByGniGroupCsv(
          data.widgetData.theme5.changeByGniGroupUserChart,
          settings
        );

        downloadAnnotatedCsv(csv, "change_by_gni_group_user_chart.csv");

        break;

      case "theme5.changeByMethodCostChart":
        csv = createChangeByMethodCsv(
          data.widgetData.theme5.changeByMethodCostChart,
          settings
        );

        downloadAnnotatedCsv(csv, "change_by_method_cost_chart.csv");

        break;

      case "theme5.changeByGniGroupCostTable":
        csv = createChangeByGniGroupTableCsv(
          data.widgetData.theme5.changeByGniGroupCostTable,
          settings
        );

        downloadAnnotatedCsv(csv, "change_by_gni_group_cost_table.csv");

        break;

      case "theme5.changeByGniGroupCostChart":
        csv = createChangeByGniGroupCsv(
          data.widgetData.theme5.changeByGniGroupCostChart,
          settings
        );

        downloadAnnotatedCsv(csv, "change_by_gni_group_cost_chart.csv");

        break;

      case "annex.contraceptionUsersTable":
        csv = createContraceptionCsv(
          data.widgetData.annex.contraceptionUsersTable,
          settings
        );

        downloadAnnotatedCsv(csv, "contraception_users_table.csv");

        break;

      case "annex.userMethodMixAndShareTable":
        csv = createMethodMixAndShareCsv(
          data.widgetData.annex.userMethodMixAndShareTable,
          settings
        );

        downloadAnnotatedCsv(csv, "user_method_mix_and_share_table.csv");

        break;

      case "annex.changeInUsersTable":
        csv = createChangeCsv(
          data.widgetData.annex.changeInUsersTable,
          settings
        );

        downloadAnnotatedCsv(csv, "change_in_users_table.csv");

        break;

      case "annex.contraceptionCostTable":
        csv = createContraceptionCsv(
          data.widgetData.annex.contraceptionCostTable,
          settings
        );

        downloadAnnotatedCsv(csv, "contraception_cost_table.csv");

        break;

      case "annex.costMethodMixAndShareTable":
        csv = createMethodMixAndShareCsv(
          data.widgetData.annex.costMethodMixAndShareTable,
          settings
        );

        downloadAnnotatedCsv(csv, "cost_method_mix_and_share_table.csv");

        break;

      case "annex.changeInCostTable":
        csv = createChangeCsv(
          data.widgetData.annex.changeInCostTable,
          settings
        );

        downloadAnnotatedCsv(csv, "change_in_cost_table.csv");

        break;

      case "annex.contraceptionQuantityTable":
        csv = createContraceptionCsv(
          data.widgetData.annex.contraceptionQuantityTable,
          settings,
          false
        );

        downloadAnnotatedCsv(csv, "contraception_quantity_table.csv");

        break;

      case "annex.quantityMethodShareTable":
        csv = createMethodMixAndShareCsv(
          data.widgetData.annex.quantityMethodShareTable,
          settings,
          false,
          false
        );

        downloadAnnotatedCsv(csv, "quantity_method_share_table.csv");

        break;

      case "annex.changeInQuantityTable":
        csv = createChangeCsv(
          data.widgetData.annex.changeInQuantityTable,
          settings,
          false
        );

        downloadAnnotatedCsv(csv, "change_in_quantity_table.csv");

        break;

      default:
        break;
    }
  };

  return (
    <App
      data={data}
      onWidgetChange={handleWidgetChange}
      onCountryExplorerWidgetChange={({ widget, payload }) => {
        console.log(`Country Explorer widget ${widget} changed`);
        console.log(payload);

        let gniGroup;

        if (payload.gniGroup) {
          gniGroup = data.databases.core.areas[payload.gniGroup].area;

          gniGroup = {
            "Low-Income (LIC)": "Low income",
            "Lower-Middle-Income (L-MIC)": "Lower middle income",
            "Upper-Middle-Income (U-MIC)": "Upper middle income"
          }[gniGroup];
        }

        if (!gniGroup) {
          return;
        }

        switch (widget) {
          case "countryExplorer.currentChart":
            setData({
              ...data,
              widgetData: {
                ...data.widgetData,
                countryExplorer: {
                  ...data.widgetData.countryExplorer,
                  currentChart: calculateCountryExplorerCurrentChartData(
                    data.databases,
                    payload.indicator,
                    gniGroup,
                    payload.method,
                    payload.sector
                  )
                }
              }
            });

            break;

          case "countryExplorer.projectionChart":
            setData({
              ...data,
              widgetData: {
                ...data.widgetData,
                countryExplorer: {
                  ...data.widgetData.countryExplorer,
                  projectionChart: calculateCountryExplorerProjectionChartData(
                    data.databases,
                    payload.indicator,
                    gniGroup,
                    payload.method
                  )
                }
              }
            });

            break;

          default:
            break;
        }
      }}
      onAnnexAreaChange={areaId => {
        setData({
          ...data,
          widgetData: {
            ...data.widgetData,
            annex: calculateAnnexTableData(data.databases, areaId)
          }
        });
      }}
      onDownloadCsv={handleDownloadCsv}
    />
  );
};

export default AppContainer;
